// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.general-wrapper {
  background-color: #f4f3ef;
  height: 100vh;
}

.login-wrapper {
  margin: 0 auto;
  margin-top: 25vh;
  width: 40%;
  min-height: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 768px) {
  .login-wrapper {
    width: 90%;
  }
}

.logo-wrapper {
  margin: 0 auto;
  width: 20%;
}
.logo-wrapper img {
  width: 100%;
  height: auto;
}

.wrapper-buttons button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap;
  padding: 2%;
}
.wrapper-buttons button img {
  width: 5%;
  height: auto;
}
.wrapper-buttons button span {
  color: #3c4858;
  margin-left: 2%;
  font-size: 1.3rem;
}
@media (max-width: 1000px) {
  .wrapper-buttons button span {
    display: none;
  }
  .wrapper-buttons button img {
    width: 20%;
  }
}
@media (min-width: 425px) and (max-width: 768px) {
  .wrapper-buttons button img {
    width: 15%;
  }
}

.example-radio-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 15px 0;
}

.example-radio-button {
  margin: 5px;
  align-items: center;
}

.image-header {
  border-radius: 3px;
  margin-top: -20px;
  max-height: 200px;
  box-shadow: 0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px #99ffe5;
  background: linear-gradient(60deg, #58d3b3, #21fcc1);
  color: white;
  position: absolute;
  top: -40px;
  width: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn ease 1s;
}
.image-header img {
  width: 200px;
  height: auto;
}

.mat-mdc-button {
  margin: 0 auto;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.image {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url('fondo-gente.png');
}

.loader {
  margin: 0 auto;
  margin-top: 30vh;
}`, "",{"version":3,"sources":["webpack://./src/app/login/login.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,aAAA;AACF;;AACA;EACE,cAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAEF;AADE;EARF;IASI,UAAA;EAIF;AACF;;AAAA;EACE,cAAA;EACA,UAAA;AAGF;AAFE;EACE,WAAA;EACA,YAAA;AAIJ;;AAGE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EAEA,WAAA;AADJ;AAEI;EACE,SAAA;EACA,YAAA;AAAN;AAEI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AAAN;AAGI;EACE;IACE,aAAA;EADN;EAGI;IACE,UAAA;EADN;AACF;AAGI;EACE;IACE,UAAA;EADN;AACF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAHF;;AAMA;EACE,WAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,uEAAA;EACA,oDAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAKA,yBAAA;AAPF;AAGE;EACE,YAAA;EACA,YAAA;AADJ;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE;IACE,UAAA;EAHF;EAKA;IACE,UAAA;EAHF;AACF;AAMA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,wCAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;AALF","sourcesContent":[".general-wrapper {\n  background-color: #f4f3ef;\n  height: 100vh;\n}\n.login-wrapper {\n  margin: 0 auto;\n  margin-top: 25vh;\n  width: 40%;\n  min-height: 30%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  @media (max-width: 768px) {\n    width: 90%;\n  }\n  \n}\n\n.logo-wrapper {\n  margin: 0 auto;\n  width: 20%;\n  img {\n    width: 100%;\n    height: auto;\n  }\n\n \n}\n\n.wrapper-buttons {\n  button {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex-wrap: wrap;\n\n    padding: 2%;\n    img {\n      width: 5%;\n      height: auto;\n    }\n    span {\n      color: #3c4858;\n      margin-left: 2%;\n      font-size: 1.3rem;\n    }\n    \n    @media (max-width: 1000px) {\n      span {\n        display: none;\n      }\n      img {\n        width: 20%;\n      }\n    }\n    @media (min-width: 425px) and (max-width: 768px) {\n      img {\n        width: 15%;\n      }\n    }\n  }\n}\n\n.example-radio-group {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 15px 0;\n}\n\n.example-radio-button {\n  margin: 5px;\n  align-items: center;\n}\n\n.image-header {\n  border-radius: 3px;\n  margin-top: -20px;\n  max-height: 200px;\n  box-shadow: 0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px #99ffe5;\n  background: linear-gradient(60deg, #58d3b3, #21fcc1);\n  color: white;\n  position: absolute;\n  top: -40px;\n  width: 95%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  img {\n    width: 200px;\n    height: auto;\n  }\n  animation: fadeIn ease 1s;\n}\n\n.mat-mdc-button {\n  margin: 0 auto;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.image {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-image: url(\"../../assets/img/fondo-gente.png\");\n}\n\n.loader {\n  margin: 0 auto;\n  margin-top: 30vh;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
